module.exports = __webpack_public_path__ + "static/favicon-fba32127188487af0c6f1e3b9c6e87bc.png";